import React from 'react';

const LearnMoreAboutMe: React.FC = () => {
  return (
    <details className="govuk-details">
      <summary className="govuk-details__summary">
        <span className="govuk-details__summary-text">Learn more About Me</span>
      </summary>
      <div className="govuk-details__text">
        <div className="govuk-body">
          The expectation is that this information would be written or recorded
          by an individual, supported by a professional or carer (or by someone
          on behalf of the person if they do not have capacity). It includes
          options to use multimedia files which are particularly useful when a
          person has difficulties expressing themselves, or for showing how to
          do things or actions and reactions.
        </div>
        <div className="govuk-body">
          It is recommended that About me information is reviewed and updated at
          key transition points for example for children and young people with
          Education, Health and Care (EHC) plans when transitioning from primary
          to secondary school, moving onto college and whenever their home
          circumstances change (for example moving into supported living or
          residential care). The transition process from children’s social care
          to adult’s social care is also a recommended time for reviewing and
          updating About Me information.
        </div>
        <div className="govuk-body">
          For adults, it should be reviewed and updated at planned reviews or
          when circumstances change. It should be possible for the individual to
          update their information whenever they want or need to. It is
          recommended the individual (or the person supporting them to write the
          information) is prompted to consider: that the most important
          information comes first in any section. avoiding adding too much
          information as important information may be buried within text making
          it difficult for the professionals to easily digest the information
          and use it to personalise care. when the use of multimedia is
          effective and ensure that videos are kept short. that they do not need
          to put information about themselves in every section, only where they
          feel they have information they want to share.
        </div>
        <div className="govuk-body">
          The sections enable the individual to record whatever is most
          important to them and therefore are broad and few in number. Local
          implementers could decide to structure the information within the
          sub-categories further. About Me elements are free text to allow the
          person to elaborate on their preferences (e.g. what matters to them).
        </div>
        <div className="govuk-body">
          To help individuals to structure their information within the sections
          a set of possible prompt questions have been included with this
          guidance, but please note that these are intended as a guide and
          should not constrain a person&apos;s responses to the sections in
          About Me. If implementers are working with a particular cohort, they
          may wish to consult guidance from relevant bodies or charities and
          tailor the prompt questions accordingly.
        </div>
      </div>
    </details>
  );
};

export default LearnMoreAboutMe;
